/**
 * SE-742: Young DIVA-5 entry points (age range page and the young questionnaire).
 * Set REACT_APP_ADHD_YOUNG_QUESTIONNAIRE_ENABLED=true to turn them on; anything else,
 * including a missing value, keeps the released adult-only questionnaire flow.
 */
export const isYoungQuestionnaireEnabled = (
  value: string | undefined = process.env.REACT_APP_ADHD_YOUNG_QUESTIONNAIRE_ENABLED,
): boolean => value === 'true';

export const YOUNG_QUESTIONNAIRE_ENABLED = isYoungQuestionnaireEnabled();
